<template>
  <div>
    <p v-if="!isValid">Form is invalid!</p>
  </div>
</template>

<script>
export default {
  name: "LocationFormValidation",
  data() {
    return {
      isValid: true,
    };
  },
  methods: {
    validateForm(formData) {
      console.log(formData);
      // Simple validation logic for example purposes
      this.isValid = formData.name.trim() !== '';
      return this.isValid;
    },
  },
};
</script>
